import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { filterDocs, groupDocs } from '../content/docsUtils';
import './Marketing.css';

function DocsIndex() {
  const groups = groupDocs(filterDocs({ access: 'public' }));

  useEffect(() => {
    document.title = 'Documentation — Racontera';
  }, []);

  return (
    <div className="docs-index">
      <h1>Documentation</h1>
      <p className="docs-index-intro">
        Guides for using Racontera. Sign in for additional team documentation.
      </p>
      {groups.length === 0 ? (
        <p>No documentation published yet.</p>
      ) : (
        groups.map((group) => (
          <section key={group.id} className="docs-group">
            <h2 className="docs-group-title">{group.label}</h2>
            <ul className="docs-list">
              {group.pages.map((page) => (
                <li key={page.slug} className="docs-list-item">
                  <Link to={`/docs/${page.slug}`} className="docs-list-link">
                    <span className="docs-list-title">{page.title}</span>
                    {page.excerpt && (
                      <span className="docs-list-excerpt">{page.excerpt}</span>
                    )}
                  </Link>
                </li>
              ))}
            </ul>
          </section>
        ))
      )}
    </div>
  );
}

export default DocsIndex;
